import { render, staticRenderFns } from "./my-swipe.vue?vue&type=template&id=7a65c3e3&scoped=true&"
import script from "./my-swipe.vue?vue&type=script&lang=js&"
export * from "./my-swipe.vue?vue&type=script&lang=js&"
import style0 from "./my-swipe.vue?vue&type=style&index=0&id=7a65c3e3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65c3e3",
  null
  
)

export default component.exports